import { ConfigMap, EnabledFieldsMap, RequestedFieldsMap } from "@/src/lib/schema-types";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getEnabledFields(): Promise<EnabledFieldsMap> {
  return fetchJSON<EnabledFieldsMap>("/api/schema/enabled-fields");
}

export async function getRequestedFields(): Promise<RequestedFieldsMap> {
  return fetchJSON<RequestedFieldsMap>("/api/schema/requested-fields");
}

export async function getConfig(): Promise<ConfigMap> {
  const response = await fetch("/api/schema/config");

  const config = (await response.json()) as ConfigMap;

  return config;
}
